export default __webpack_public_path__ + "static/media/miut_streets.5456c290.jpg";